import { useNavigate } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'

import DeleteActionModal from 'modules/automations/components/DeleteActionModal'

const DeleteActionModalPage = () => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const { id, action_id } = useStrictParams<'id' | 'action_id'>()

  const onClose = () => {
    navigate(navigation.settings.automations.id.fullPath({ id }))
  }

  return <DeleteActionModal actionId={Number(action_id)} onClose={onClose} />
}

export default DeleteActionModalPage
